<input
    #input
    id="auto-input-delimiter"
    [(ngModel)]="inputValue"
    (ngModelChange)="updateInput($event)"
    (keydown)="onKey($event)"
    (blur)="formatFinalValue($event)"
    [style.width]="params.column.actualWidth + 'px'"
/>
